module.exports = __webpack_public_path__ + "img/wzzj3-1.0b54cba1.jpg";